import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ChiSiamo from "@/components/ChiSiamo";
import MenuSection from "@/components/MenuSection";
import DjSection from "@/components/DjSection";
import Gallery from "@/components/Gallery";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import AdminPage from "@/components/AdminPage";

function Home() {
  return (
    <div className="bg-[#0D0D0F] text-[#F5F2EB] font-body antialiased">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <ChiSiamo />
        <MenuSection />
        <DjSection />
        <Gallery />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, anchors: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gestione" element={<AdminPage />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}
